import axios from 'axios';

// -------------------------------------------------
// Axios instances
// -------------------------------------------------
export const serverUrl = axios.create({
  // baseURL: "http://127.0.0.1:8000/api/",
  baseURL: 'https://artiza.co.ke/api/', // Production server
  withCredentials: true,
});

export const serverUrlAuth = axios.create({
  // baseURL: "http://127.0.0.1:8000/api/",
  baseURL: 'https://artiza.co.ke/api/', // Production server
  withCredentials: true,
});

// -------------------------------------------------
// Helpers
// -------------------------------------------------
const getTokens = () => ({
  access: localStorage.getItem('access_token'),
  refresh: localStorage.getItem('refresh_token'),
});

const setAccessToken = (token) => {
  localStorage.setItem('access_token', token);
};

const logout = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  window.location.href = '/login'; // redirect to login
};

// -------------------------------------------------
// Request interceptor: attach access token
// -------------------------------------------------
serverUrlAuth.interceptors.request.use((config) => {
  const { access } = getTokens();
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});

// -------------------------------------------------
// Response interceptor: handle expired/invalid token
// -------------------------------------------------
serverUrlAuth.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.data.code === 'token_not_valid' &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const { refresh } = getTokens();

      if (refresh) {
        try {
          const res = await serverUrl.post('users/token/refresh/', { refresh });

          setAccessToken(res.data.access);
          originalRequest.headers.Authorization = `Bearer ${res.data.access}`;

          return axios(originalRequest);
        } catch (err) {
          logout(); // refresh failed → log out
          return Promise.reject(err);
        }
      } else {
        logout(); // no refresh token → log out
      }
    }

    return Promise.reject(error);
  },
);